import { render, staticRenderFns } from "./ProfileAdmin.vue?vue&type=template&id=7cf54d4a"
import script from "./ProfileAdmin.vue?vue&type=script&lang=js"
export * from "./ProfileAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports